import React from 'react'

/**
 * An iPhone 17 Pro-style device frame drawn in CSS: titanium band, black
 * bezel, side buttons, Dynamic Island and a faint glass sheen. The screen is
 * exactly 1206 × 2622 (the 17 Pro's native ratio), so screenshots and screen
 * recordings fill it edge to edge without letterboxing.
 */
export default function IPhoneFrame({
  children,
  className = '',
  island = true,
}: {
  children: React.ReactNode
  className?: string
  island?: boolean
}) {
  return (
    <div className={`relative ${className}`}>
      {/* Side buttons: action + volume on the left, power and camera control on the right */}
      <span aria-hidden="true" className="absolute -left-[3px] top-[16%] h-[5%] w-[4px] rounded-l-sm bg-gradient-to-b from-[#9aa0a6] via-[#5b6067] to-[#3a3e43]" />
      <span aria-hidden="true" className="absolute -left-[3px] top-[24%] h-[8.5%] w-[4px] rounded-l-sm bg-gradient-to-b from-[#9aa0a6] via-[#5b6067] to-[#3a3e43]" />
      <span aria-hidden="true" className="absolute -left-[3px] top-[34.5%] h-[8.5%] w-[4px] rounded-l-sm bg-gradient-to-b from-[#9aa0a6] via-[#5b6067] to-[#3a3e43]" />
      <span aria-hidden="true" className="absolute -right-[3px] top-[26%] h-[12%] w-[4px] rounded-r-sm bg-gradient-to-b from-[#9aa0a6] via-[#5b6067] to-[#3a3e43]" />
      <span aria-hidden="true" className="absolute -right-[2px] top-[58%] h-[6%] w-[3px] rounded-r-sm bg-gradient-to-b from-[#7d838a] to-[#3a3e43]" />

      {/* Titanium band */}
      <div className="relative rounded-[13.5%/6.4%] bg-[linear-gradient(145deg,#c9ccd0_0%,#6f747a_22%,#2f3236_48%,#5d6268_74%,#b7bbc0_100%)] p-[1.6%] shadow-[0_40px_80px_-24px_rgba(0,0,0,0.55),0_18px_36px_-18px_rgba(0,0,0,0.45)]">
        {/* Black bezel */}
        <div className="relative rounded-[12.4%/5.85%] bg-[#050606] p-[2.6%]">
          {/* Screen */}
          <div className="relative aspect-[1206/2622] overflow-hidden rounded-[10.6%/4.9%] bg-black isolate">
            {children}
            {island ? (
              <span
                aria-hidden="true"
                className="pointer-events-none absolute left-1/2 top-[1.35%] z-20 h-[3.55%] w-[31%] -translate-x-1/2 rounded-full bg-black"
              >
                <span className="absolute right-[13%] top-1/2 h-[42%] aspect-square -translate-y-1/2 rounded-full bg-[radial-gradient(circle_at_35%_35%,#2c3a52,#0b0d12_70%)]" />
              </span>
            ) : null}
            {/* Glass sheen */}
            <span
              aria-hidden="true"
              className="pointer-events-none absolute inset-0 z-10 bg-[linear-gradient(115deg,rgba(255,255,255,0.10)_0%,rgba(255,255,255,0)_32%,rgba(255,255,255,0)_70%,rgba(255,255,255,0.05)_100%)]"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
